import Skeleton from '../presentational/skeleton';
import { DynamicPaneContent } from '../presentational/layouts';
import { useSelector } from 'react-redux';
import { featuresSelector } from '../../scripts/selectors/global';

const SkeletonRaidRankingsPage = () => {
  const currentFeatures = useSelector(featuresSelector);

  const skeletonPaginationButtons = (
    <div style={{ display: 'flex', margin: '12px 0' }}>
      <Skeleton width={68} height={27} style={{ marginRight: 16, borderRadius: '0.25rem' }} />
      <Skeleton width={69} height={27} style={{ marginRight: 16, borderRadius: '0.25rem' }} />
      <Skeleton width={71} height={27} style={{ marginRight: 16, borderRadius: '0.25rem' }} />
      <Skeleton width={67} height={27} style={{ marginRight: 16, borderRadius: '0.25rem' }} />
    </div>
  );

  return (
    <div>
      <Skeleton height={350} style={{ padding: '12px 16px' }}>
        <Skeleton variant="item" width={500} height={25} style={{ marginBottom: 12 }} animate />
        <div style={{ maxWidth: 790, display: 'flex', height: 'max-content' }}>
          <Skeleton
            variant="item"
            width={230}
            height="37.5px"
            style={{ marginRight: 8, borderRadius: '0.25rem' }}
            animate
          />
          <Skeleton
            variant="item"
            width={100}
            height="37.5px"
            style={{ marginRight: 8, borderRadius: '0.25rem' }}
            animate
          />
          <Skeleton
            variant="item"
            width={82}
            height="37.5px"
            style={{ marginRight: 8, borderRadius: '0.25rem' }}
            animate
          />
          <Skeleton
            variant="item"
            width={77}
            height="37.5px"
            style={{ marginRight: 8, borderRadius: '0.25rem' }}
            animate
          />
          <Skeleton
            variant="item"
            width={109}
            height="37.5px"
            style={{ marginRight: 8, borderRadius: '0.25rem' }}
            animate
          />
          <Skeleton
            variant="item"
            width={124}
            height="37.5px"
            style={{ marginRight: 8, borderRadius: '0.25rem' }}
            animate
          />
        </div>
      </Skeleton>
      <DynamicPaneContent>
        <>
          <Skeleton height={287} style={{ display: 'flex' }}>
            <div style={{ margin: 'auto' }}>
              <Skeleton variant="item" width={350} height={20} style={{ marginBottom: 8 }} animate />
              <Skeleton variant="item" width={350} height={200} animate />
              <div style={{ display: 'flex' }}>
                <Skeleton variant="item" width={80} height={20} style={{ margin: 'auto', marginTop: 8 }} animate />
              </div>
            </div>
          </Skeleton>

          {currentFeatures.no_ads && <Skeleton height={103} style={{ marginTop: 24 }} />}

          <div style={{ marginTop: '1rem' }}>
            {skeletonPaginationButtons}
            <Skeleton height={36} />
            <Skeleton variant="item" height={1090} />
            {skeletonPaginationButtons}
          </div>
        </>
        <>
          <Skeleton height={23} />
          <Skeleton variant="item" height={288} />
        </>
      </DynamicPaneContent>
    </div>
  );
};

export default SkeletonRaidRankingsPage;

